import { render } from "./PatientInfo.vue?vue&type=template&id=7dab2c84&scoped=true"
import script from "./PatientInfo.vue?vue&type=script&lang=js"
export * from "./PatientInfo.vue?vue&type=script&lang=js"

import "./PatientInfo.vue?vue&type=style&index=0&id=7dab2c84&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dab2c84"]])

export default __exports__